


export default function PostFooter(props) {
	return (
		<div class="container">
        
        {/* ccw 2026-09-27 [bp-disclosures-link]: target for "For important additional information, click here" in AppLogged.js.
            The old anchor lived in DisclosuresHTML, which stopped being rendered in 2022. */}
        <section id="bp-disclosures">
		
			
					<div className="row body-section">
						<div className="vm">
		<h3>Important Notes</h3>

		<p className="strong">
			Past performance does not guarantee future results. Investing involves risk, including possible loss of principal.
		</p>

		<p className="strong">
			This information should not be relied upon as research, investment advice, or a recommendation regarding any products,
			strategies, or any security in particular. This material is strictly for illustrative, educational, or informational
			purposes and is subject to change.
		</p>

		<p>
			The opinions expressed are those of the portfolio management teams as on 6/30/2025 and may change as subsequent conditions
			vary. Information and opinions are derived from proprietary and nonproprietary sources deemed by BlackRock to be reliable,
			are not necessarily all-inclusive and are not guaranteed as to accuracy.
		</p>

		<p>
			<strong>Important Risks:</strong> The BlackRock funds are actively managed and their characteristics will vary. Bond values
			fluctuate in price so the value of your investment can go down depending on market conditions. Fixed income risks include
			interest-rate and credit risk. Typically, when interest rates rise, there is a corresponding decline in bond values. Credit
			risk refers to the possibility that the bond issuer will not be able to make principal and interest payments. Principal of
			mortgage- or asset-backed securities normally may be prepaid at any time, reducing the yield and market value of those
			securities. Obligations of U.S. gov’t agencies are supported by varying degrees of credit but generally are not backed by
			the full faith and credit of the U.S. gov’t. The fund may use derivatives to hedge its investments or to seek to enhance
			returns. Derivatives entail risks relating to liquidity, leverage and credit that may reduce returns and increase volatility.
			International investing involves special risks including, but not limited to currency fluctuations, illiquidity and
			volatility. These risks may be heightened for investments in emerging markets. Non-investment-grade debt securities (high
			yield/junk bonds) may be subject to greater market fluctuations, risk of default or loss of income and principal than
			higher-rated securities. Short selling entails special risks. If the fund makes short sales in securities that increase in
			value, the fund will lose value. Any loss on short positions may or may not be offset by investing short-sale proceeds in
			other investments.
		</p>

		<p>
			iShares index funds are not actively managed and will not attempt to take defensive positions under any market conditions,
			including declining markets. Transactions in shares of ETFs will result in brokerage commissions and will generate tax
			consequences. All regulated investment companies are obliged to distribute portfolio gains to shareholders.
		</p>

		<p>
			Diversification and asset allocation may not protect against market risk or loss of principal.
		</p>

		<p>
			The tool, and any data used by the tool, is provided on an &quot;as-is&quot; basis. BlackRock expressly disclaims all
			warranties, express or implied, statutory or otherwise with respect to the tool (and any data used by the tool and the
			results obtained from use of the tool) including, without limitation, all warranties or merchantability, fitness for a
			particular purpose or use, accuracy, completeness, originality and/or non-infringement. In no event shall BlackRock have
			any liability for any claims, damages, obligations, liabilities or losses relating to the tool including, without
			limitation, any liability for any direct, indirect, special, incidental, punitive and/or consequential damages (including
			loss of profits or principal).
		</p>

		<p>
			Investment comparisons are for illustrative purposes only. To better understand the similarities and differences between
			investments, including investment objectives, risks, fees and expenses, it is important to read the products&apos;
			prospectuses.
		</p>

		<p className="strong">
			Must be preceded or accompanied by a prospectus for 
            
            &nbsp;<a href="https://www.blackrock.com/us/financial-professionals/products/331752/" target="_blank">iShares Flexible Income Active ETF</a>,&nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227557/" target="_blank">BlackRock High Yield Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227615/" target="_blank">BlackRock Income Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/288478/" target="_blank">iShares High Yield Systematic Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/291299/" target="_blank">iShares Broad USD High Yield Corporate Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227660/" target="_blank">BlackRock Strategic Income Opportunities Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239854/" target="_blank">iShares Short Duration Bond Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227598/" target="_blank">BlackRock Low Duration Bond Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/314116/" target="_blank">iShares 0-3 Month Treasury Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239450/" target="_blank">iShares 0-5 Year TIPS Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227777/" target="_blank">BlackRock Total Return Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227526/" target="_blank">BlackRock Core Bond Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239458/" target="_blank">iShares Core U.S. Aggregate Bond ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/264615/" target="_blank">iShares Core Total USD Bond Market ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/341516/" target="_blank">iShares High Yield Muni Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/317978/" target="_blank">iShares High Yield Muni Income Active ETF</a>,&nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/272112/" target="_blank">iShares Short Maturity Municipal Bond Active ETF</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227663/" target="_blank">BlackRock Short Duration Muni Fund</a>, &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/227581/" target="_blank">BlackRock Strategic Municipal Opportunities Fund</a>, and &nbsp; 
	<a href="https://www.blackrock.com/us/financial-professionals/products/239766/" target="_blank">iShares National Muni Bond ETF</a>.
            
            
            
           Read the prospectus carefully before investing.
		</p>

		<p>
			Please ask your clients to consider the investment objectives, risks, charges and expenses of the funds carefully before
			investing. The prospectuses and, if available, the summary prospectuses contain this and other information about the funds
			and are available, along with information on other BlackRock funds, by calling 800-882-0052 or at{" "}
			<a href="https://www.blackrock.com" target="_blank" rel="noreferrer">
				www.blackrock.com
			</a>
			. The prospectuses and, if available, the summary prospectuses should be read carefully before investing.
		</p>

		<p>
			©2026 BlackRock, Inc. or its affiliates. All Rights Reserved. BLACKROCK, iSHARES and ALADDIN are trademarks of BlackRock,
			Inc. or its affiliates. All other trademarks are those of their respective owners.
		</p>

		<p>
			Prepared by BlackRock Investments, LLC, member FINRA.
		</p>

		<p>USRRMH1025U/S-4828207</p>
	</div>
               		</div>
            
        
        </section>

        </div>
	)
}